import React from "react";
import { Sheet, Typography, Box } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";

interface SummaryStatCardProps {
  value: string | number;
  label: string;
  valueColor?: string;
  icon?: React.ReactNode;
  sx?: SxProps;
}

export const SummaryStatCard: React.FC<SummaryStatCardProps> = ({
  value,
  label,
  valueColor = "primary",
  icon,
  sx,
}) => {
  return (
    <Sheet
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 1 },
        borderRadius: "md",
        boxShadow: "sm",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "100%",
        width: "125px",
        ...sx,
      }}
    >
      {icon && (
        <Box sx={{ mb: 0.5, color: `${valueColor}.plainColor` }}>{icon}</Box>
      )}
      <Typography
        // level="p"
        textColor={`${valueColor}.solidBg`}
        sx={{ fontWeight: "bold" }}
      >
        {value}
      </Typography>
      <Typography level="body-sm" textColor="text.secondary" sx={{ mt: 0.25 }}>
        {label}
      </Typography>
    </Sheet>
  );
};
